import { useCallback, useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import Loader from "react-loader-spinner";
import httpClient from "../../custom-hooks/httpClient";

function WebcamModal({ showModal, toggleShowModal, handleChangeFile }) {
  const documentModelRef = useRef();
  const webcamRef = useRef(null);
  const capturedImgRef = useRef(null);

  const [isCaptured, setIsCaptured] = useState(false);
  const [isProcessingCapture, setIsProcessingCapture] = useState(false);
  const [captureResult, setCaptureResult] = useState({
    isBadPicture: false,
    message: "",
  });
  const [b64Image, setb64Image] = useState("");

  const handleSubmit = () => {
    handleChangeFile(b64Image);
    setIsCaptured(false);
    toggleShowModal();
  };

  const capture = useCallback(() => {
    setIsProcessingCapture(true);
    const imageSrc = webcamRef.current.getScreenshot();

    // check if image is a face
    httpClient
      .post(`/services/detect-face`, { image: imageSrc })
      // { headers: { "Content-type": "application/json" } }
      .then(({ status, data }) => {
        setIsProcessingCapture(false);
        setCaptureResult({
          ...captureResult,
          isBadPicture: false,
          message: "",
        });
        if (status === 200) {
          capturedImgRef.current.setAttribute("src", imageSrc);
          setIsCaptured(true);
          setb64Image(imageSrc);
        }
      })
      .catch((err) => {
        setIsProcessingCapture(false);
        setCaptureResult({
          ...captureResult,
          isBadPicture: true,
          message:
            (err && err.response && err.response.data.message) ||
            "Picture quality is bad",
        });
        // console.log(err.response.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [webcamRef]);

  useEffect(() => {
    document.addEventListener("keydown", (e) =>
      e.key === "Escape" && showModal ? toggleShowModal() : null
    );
    return () =>
      document.removeEventListener("keydown", (e) =>
        e.key === "Escape" && showModal ? toggleShowModal() : null
      );
  }, [showModal, toggleShowModal]);
  return (
    <div
      className={`modal fade bg-dark ${showModal ? "show" : ""}`}
      id="modalExample"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modalExampleTitle"
      aria-hidden="true"
      style={{ display: showModal ? "block" : "none" }}
      ref={documentModelRef}
      onClick={(e) =>
        documentModelRef.current === e.target ? toggleShowModal() : null
      }
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-body">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setIsCaptured(false);
                toggleShowModal();
              }}
            ></button>

            {captureResult.isBadPicture && (
              <p className="fs-lg text-center text-warning">
                {captureResult.message}
              </p>
            )}

            {isCaptured ? (
              <p className="fs-lg text-center text-muted">
                Accept the captured photo or take another shot
              </p>
            ) : (
              <p className="fs-lg text-center text-muted">
                Ensure you have good background lighting and position your face
                to fit the camera window
              </p>
            )}

            <img
              alt="Webcam captured"
              className="img-fluid mb-3"
              style={{ display: !isCaptured && "none", width: "100%" }}
              // src="https://storage.googleapis.com/kegow-public/tony-stark.jpeg"
              ref={capturedImgRef}
            />

            {showModal && !isCaptured && (
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width="100%"
                videoConstraints={{ facingMode: "user" }}
              />
            )}

            <div className="row">
              {isCaptured ? (
                <>
                  <div className="col-12">
                    <button
                      className="btn w-100 btn-primary-soft mt-3 lift"
                      onClick={handleSubmit}
                    >
                      Accept
                    </button>
                  </div>
                  <div className="col-12">
                    <button
                      className="btn w-100 btn-secondary-soft mt-3 lift"
                      onClick={() => setIsCaptured(false)}
                    >
                      Recapture
                    </button>
                  </div>
                </>
              ) : (
                <div className="col-12">
                  {isProcessingCapture ? (
                    <button
                      className="btn w-100 btn-primary mt-3 lift"
                      disabled
                    >
                      <Loader type="Oval" color="#fff" width={20} height={20} />
                    </button>
                  ) : (
                    <button
                      className="btn w-100 btn-primary mt-3 lift"
                      onClick={capture}
                    >
                      Capture
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WebcamModal;
